import type { AbsenceType } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import { useQuery } from 'react-query'
import { ABSENCE_TYPES_QUERY_KEY, ABSENCE_TYPES_URL } from './queryConstants'

export type AbsenceTypesFormType = {
  absenceTypes: AbsenceType[]
}

type UseAbsenceTypesListReturn = {
  absenceTypes: AbsenceType[]
  isAbsenceTypesLoading: boolean
  refetch: () => void
}

export const useAbsenceTypesList = (): UseAbsenceTypesListReturn => {
  const {
    data: absences,
    isLoading,
    refetch
  } = useQuery(
    [ABSENCE_TYPES_QUERY_KEY] as string[],
    () =>
      getJSON({
        url: ABSENCE_TYPES_URL,
        isRota: true
      }),
    { enabled: true }
  )

  return {
    absenceTypes: absences?.data || [],
    isAbsenceTypesLoading: isLoading,
    refetch
  }
}
